import 'Styles/pageselector.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import SvgIcon from 'Components/svg/SvgIcon';
import { trackGAEvent } from 'Actions/adsActions';
import { openIOSKeyboard, closeIOSKeyboard } from 'Actions/UiActions';
import { deviceType } from 'Utils/deviceType';

class PageSelectorComponent extends React.Component {
	constructor( props ) {
		super( props );
		this.state = {
			isOpen: false,
			jumpPage: props.currentPage
		};
	}

	shouldComponentUpdate( nextProps, nextState ) {
		return (
			nextProps.bottomAdPos !== this.props.bottomAdPos ||
			nextProps.currentPage !== this.props.currentPage ||
			nextProps.totalPages !== this.props.totalPages ||
			nextProps.bottomPosition !== this.props.bottomPosition ||
			nextState.isOpen !== this.state.isOpen ||
			nextState.jumpPage !== this.state.jumpPage
		)
	}

	componentWillReceiveProps( nextProps ) {
		this.setState( {
			jumpPage: nextProps.currentPage
		} )
	}

	toggleBody = () => {
		this.setState( {
			isOpen: !this.state.isOpen
		} );
	};

	onPageInputChange = ( e ) => {
		let newPage = parseInt( e.target.value );

		this.setState( {
			jumpPage: isNaN( newPage ) ? null : newPage
		} );
	};

	onFirstButtonClick = () => {
		this.setState( {
			isOpen: false
		} );

		if( this.props.onFirstButtonClick ) {
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'firstPage', 'uiAction', 'pageSelector' ) );
			this.props.onFirstButtonClick();
		}
	};

	onLastButtonClick = () => {
		this.setState( {
			isOpen: false
		} );

		if( this.props.onLastButtonClick ) {
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'lastPage', 'uiAction', 'pageSelector' ) );
			this.props.onLastButtonClick();
		}
	};

	onJumpPage = ( e ) => {
		e.preventDefault();

		// Validate input
		let newPage = this.state.jumpPage;

		if( isNaN( newPage ) ) {
			newPage = this.props.currentPage;
		}

		if( newPage < 1 ) {
			newPage = 1;
		}

		if( newPage > this.props.totalPages ) {
			newPage = this.props.totalPages;
		}

		this.setState( {
			isOpen: false,
			jumpPage: newPage
		} );

		if( this.props.onJumpPage ) {
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'jumpPage', 'uiAction', 'pageSelector' ) );

			this.props.dispatch( closeIOSKeyboard() );
			this.props.onJumpPage( newPage );
		}
	};

	focusInput = () => {
		let deviceInfo = deviceType();

		// iOS breaks things when the keyboard opens
		if( deviceInfo.any && deviceInfo.os.platform.ios !== false && this.deviceInfo.browser.engine === 'Safari' ) {
			this.props.dispatch( openIOSKeyboard() );
		}
	};

	blurInput = () => {
		// we need to delay this action because iOS won't trigger the submit action
		setTimeout( () => this.props.dispatch( closeIOSKeyboard() ), 150);
	};

	render() {
		let { currentPage, totalPages, bottomPosition } = this.props;
		let { isOpen, jumpPage } = this.state;

		if( isNaN( totalPages ) || totalPages <= 1 ) {
			return <span />
		}

		return (
			<div className="page-selector" style={{ bottom: bottomPosition + 'px' }}>
				<div className="page-selector-header" onClick={ this.toggleBody }>
					<span>{currentPage} / {totalPages}</span>
					<span className="toggle-icon">
					<SvgIcon size="18px" icon={isOpen ? "angle_down" : "angle_up"}/>
				</span>
				</div>
				<div className={"page-selector-body" + (isOpen ? "" : " hidden") }>
					<div>
						<button className={ "full-width" + ( currentPage === 1 ? ' disabled' : '' ) } onClick={this.onFirstButtonClick}>
							<SvgIcon size="1.5em" icon="first_page"/> First page
						</button>
					</div>
					<div className={ parseInt( totalPages ) <= 2 ? 'hidden' : '' }>
						<input className="page-input" type="number" value={ jumpPage || '' }
							onChange={ this.onPageInputChange }
							onFocus={ this.focusInput }
							onBlur={ this.blurInput }
						/>
						<button className="jump-button" onClick={ this.onJumpPage } >Jump</button>
					</div>
					<div>
						<button className={ "full-width" + ( currentPage === totalPages ? ' disabled' : '' ) } onClick={this.onLastButtonClick}>
							Last page <SvgIcon size="1.5em" icon="last_page"/></button>
					</div>
				</div>
			</div>
		);
	}
}

PageSelectorComponent.propTypes = {
	currentPage: PropTypes.number.isRequired,
	totalPages: PropTypes.number.isRequired,
	onFirstButtonClick: PropTypes.func,
	onLastButtonClick: PropTypes.func,
	onJumpPage: PropTypes.func
};

const mapStateToProps = ( state ) => {
	return {
		bottomAdPos: ( state.ads.adSlots && state.ads.adSlots.Fixed_Bottom_Leaderboard )
	}
};

export default connect( mapStateToProps )( PageSelectorComponent );



// WEBPACK FOOTER //
// ./src/components/infiniteScroll/PageSelectorComponent.js